import { Button, Modal } from 'antd';
import { hideConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { DialogIcon } from './DialogIcon';
import { ConfirmModalProps } from './Modal.type';

export const ConfirmModalComponent = ({
    open = true,
    type,
    title,
    message,
    icon,
    okText = 'はい',
    cancelText = 'いいえ',
    closeText,
    onCancel,
    onOk,
    returnValue,
    okButtonProps,
    cancelButtonProps,
}: ConfirmModalProps) => {
    const dispatch = useAppDispatch();

    const handleOk = () => {
        dispatch(hideConfirm());
        if (returnValue) {
            onOk && onOk(returnValue);
            return;
        }
        onOk && onOk(true);
    };

    const handleCancel = () => {
        dispatch(hideConfirm());
        if (returnValue) {
            onCancel && onCancel(returnValue);
            return;
        }
        onCancel && onCancel();
    };

    const handleClose = () => {
        dispatch(hideConfirm());
    };
    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <DialogIcon type={type} icon={icon} />
                </div>
                <div className="confirm-modal-2-title" style={{ marginBottom: 8, marginTop: 32 }}>
                    {title}
                </div>
                <div
                    className="confirm-modal-2-description"
                    style={{ marginBottom: 32, color: '' }}
                >
                    {message}
                </div>
                <Button
                    type="primary"
                    className="button-login-text"
                    {...okButtonProps}
                    style={{ width: '100%', height: 48, marginBottom: 12, ...okButtonProps?.style }}
                    onClick={() => handleOk()}
                >
                    {okText}
                </Button>
                <Button
                    type="link"
                    block
                    className="text-button-cancel"
                    style={{ width: '100%', height: 48 }}
                    onClick={() => handleCancel()}
                    {...cancelButtonProps}
                >
                    {cancelText}
                </Button>
                {closeText && (
                    <Button
                        type="primary"
                        block
                        className="button-login-text"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleClose()}
                        {...cancelButtonProps}
                    >
                        {closeText}
                    </Button>
                )}
            </section>
        </Modal>
    );
};
